const GET_FILTER_LIST = process.env.VUE_APP_ROOT_API + 'get_journal_lpo_filter_list.php';

export default {
  state: {
    filterObj: {
      fo: [],
      region: [],
      forestry: [],
      localforestry: [],
      subforestry: [],
      area: [],
      section: [],
      section_lp: [],
      inspection_type: [],
      inspection_date: [],
    },

    filterList: [],
  },
  getters: {
    journalIsFiltered: state => {
      for (const columnName in state.filterObj) {
        if (state.filterObj[columnName].length) {
          return true;
        }
      }
      return false;
    },
    columnIsFiltered: state => columnName => {
      return state.filterObj[columnName].length ? true : false;
    },

    filterStr: state => {
      let filter_str = '';

      for (const column in state.filterObj) {
        if (state.filterObj[column].length) {
          filter_str += '(';
          for (const item of state.filterObj[column]) {
            
            if (item === null)
              filter_str += `${column} is null or `;
            else
              filter_str += `${column}=''${item}'' or `;
          }
          filter_str = filter_str.slice(0, -3); // вырезаем последние лишние 'or '
          filter_str += ')';
          filter_str += ' and ';
        }
      }

      filter_str = filter_str.slice(0, -4); // вырезаем последний лишний 'and '
      return filter_str;
    },
    /** Получение строки фильтра без учета текущей колонки */
    filterStrForList: state => filterColumn => {
      let filter_str = '';

      for (const column in state.filterObj) {
        if (column == filterColumn) continue;

        if (state.filterObj[column].length) {
          filter_str += '(';
          for (const item of state.filterObj[column]) {
            
            if (item === null)
              filter_str += `${column} is null or `;
            else
              filter_str += `${column}=''${item}'' or `;
          }
          filter_str = filter_str.slice(0, -3); // вырезаем последние лишние 'or '
          filter_str += ')';
          filter_str += ' and ';
        }
      }

      filter_str = filter_str.slice(0, -4); // вырезаем последний лишний 'and '
      return filter_str;
    }
  },
  mutations: {
    clearFilterAll(state, payload) {
      for (let column in state.filterObj) {
        state.filterObj[column] = [];
      }
    },

    setFilterObjColumnItems(state, payload) {
      const { column, checkedItems } = payload;
      state.filterObj[column] = checkedItems;
    },

    setFilterList(state, payload) {
      state.filterList = payload;
    },
    clearFilterList(state, payload) {
      state.filterList = [];
    },
  },

  actions: {
    clearFilterAll(context, payload) {
      const { commit } = context;

      commit('clearFilterAll', payload);
      return Promise.resolve();
    },

    setFilterObjColumnItems(context, payload) {
      const { commit } = context;

      commit('setFilterObjColumnItems', payload);
      return Promise.resolve();
    },

    getFilterList(context, filterColumn) {
      const { getters, commit, dispatch } = context;

      const form = new FormData();

      // console.log('getFilterList');
      // return;
      form.append('column', filterColumn);
      form.append('filter', getters.filterStrForList(filterColumn));

      fetch(GET_FILTER_LIST, {
        credentials: 'include',
        method: 'post',
        body: form
      })
      .then(res => res.json())
      .then(res => {
        commit('setFilterList', res);
      })
      .catch(err => new Error(err));
    },

  } 
};